import { proxy } from "valtio";
import type {
  AuthStatus,
  AuthUser,
  TokenPair,
  AuthProvider,
  AuthError,
} from "../types";

export const authStore = proxy<{ status: AuthStatus }>({
  status: { state: "idle" },
});

export const authActions = {
  startRestore(): void {
    authStore.status = { state: "restoring" };
  },

  startAuth(provider: AuthProvider): void {
    authStore.status = { state: "authenticating", provider };
  },

  setAuthenticated(user: AuthUser, tokens: TokenPair): void {
    authStore.status = { state: "authenticated", user, tokens };
  },

  setError(error: AuthError): void {
    authStore.status = { state: "error", error };
  },

  reset(): void {
    authStore.status = { state: "idle" };
  },

  /** 刷新成功后仅更新 tokens，不改变 user */
  updateTokens(tokens: TokenPair): void {
    if (authStore.status.state === "authenticated") {
      authStore.status.tokens = tokens;
    }
  },
};
